(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["curling-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("curling-look")) {
  customElements.define("curling-look", class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector("dialog");
      this.openButton = this.querySelector("[data-look-open]");
      this.addButton = this.querySelector("[data-look-add]");
      this.status = this.querySelector("[data-look-status]");
      this.rows = Array.from(this.querySelectorAll("[data-look-item]"));
      this.currency = new Intl.NumberFormat(document.documentElement.lang || "fr", {style:"currency",currency:this.dataset.currency || "EUR"});
      this.openButton.hidden = false;
      this.openButton.addEventListener("click", () => this.open());
      this.querySelector("[data-look-close]").addEventListener("click", () => { if (!this.busy) this.dialog.close(); });
      this.dialog.addEventListener("cancel", event => { if (this.busy) event.preventDefault(); });
      this.dialog.addEventListener("close", () => this.release());
      this.dialog.addEventListener("click", event => { if (event.target === this.dialog && !this.busy) { const b=this.dialog.getBoundingClientRect(); if(event.clientX<b.left || event.clientX>b.right || event.clientY<b.top || event.clientY>b.bottom) this.dialog.close(); } });
      this.querySelector("[data-look-retry]").addEventListener("click", () => this.refresh());
      this.addButton.addEventListener("click", () => this.add());
      this.dialog.addEventListener("change", event => {
        const row=event.target.closest("[data-look-item]");
        if (!row) return;
        if (event.target.matches("[data-look-variant]")) row.querySelector("[data-look-include]").checked = !!event.target.value;
        this.status.textContent="";
        this.update();
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); this.release(); }
    }
    release() {
      if (this.previousOverflow !== undefined) { document.documentElement.style.overflow=this.previousOverflow; this.previousOverflow=undefined; }
      this.openButton?.setAttribute("aria-expanded","false");
    }
    open() {
      this.previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow="hidden";
      this.dialog.showModal();
      this.openButton.setAttribute("aria-expanded","true");
      this.querySelector("[data-look-close]").focus();
      this.refresh();
    }
    async refresh() {
      if (this.busy || this.loading) return;
      this.loading=true;
      this.status.textContent=this.dataset.loading;
      this.addButton.disabled=true;
      const changed=[];
      await Promise.all(this.rows.map(async row => {
        const select=row.querySelector("[data-look-variant]"), check=row.querySelector("[data-look-include]"), message=row.querySelector("[data-look-item-status]");
        const previous=select.value;
        row.ready=false;
        select.disabled=true;
        check.disabled=true;
        try {
          const response=await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(row.dataset.handle)}.js`,{cache:"no-store",headers:{Accept:"application/json"}});
          if (!response.ok) throw new Error("product");
          const product=await response.json();
          row.variants=product.variants;
          const changing=product.options.filter(option => option.values.length>1);
          const sizeOnly=changing.length===1 && /^(size|taille|talla)$/i.test(changing[0].name);
          const prompt=sizeOnly ? this.dataset.choose : this.dataset.options;
          const options=[new Option(prompt,"")];
          product.variants.forEach(variant => {
            const parts=changing.map(option => variant.options[option.position-1]);
            const label=parts.join(" / ") || (variant.title==="Default Title" ? this.dataset.unique : variant.title);
            const option=new Option(`${label}${variant.available ? "" : " — "+this.dataset.soldout}`,String(variant.id));
            option.disabled=!variant.available;
            options.push(option);
          });
          select.replaceChildren(...options);
          const available=product.variants.some(variant=>variant.available);
          check.disabled=!available;
          if (!available) check.checked=false;
          if (product.variants.length===1 && available) select.value=String(product.variants[0].id);
          else if (previous && product.variants.some(v=>String(v.id)===previous && v.available)) select.value=previous;
          else if (previous) { changed.push(row); }
          select.hidden=product.variants.length===1;
          select.disabled=!available;
          message.textContent=!available ? this.dataset.soldout : product.variants.length===1 ? (product.variants[0].title==="Default Title" ? this.dataset.unique : product.variants[0].title) : "";
          row.ready=true;
        } catch {
          check.checked=false;
          message.textContent=this.dataset.stockError;
        }
      }));
      this.loading=false;
      this.status.textContent=changed.length ? this.dataset.changed : "";
      this.update();
    }
    update() {
      let count=0,total=0,missing=0;
      this.rows.forEach(row=> {
        const variant=row.variants?.find(v=>String(v.id)===row.querySelector("[data-look-variant]").value);
        if (variant) row.querySelector("[data-look-price]").textContent=this.currency.format(variant.price/100);
        if (!row.querySelector("[data-look-include]").checked || !row.ready) return;
        count++;
        if (!variant?.available) missing++; else total+=variant.price;
      });
      this.querySelector("[data-look-total]").textContent=missing ? this.dataset.pending : `${this.dataset.total} : ${this.currency.format(total/100)}`;
      this.addButton.disabled=this.busy || this.loading || count===0;
      this.addButton.textContent=this.busy ? this.dataset.adding : this.dataset.add;
    }
    async add() {
      if (this.busy || this.loading) return;
      const selected=this.rows.filter(row=>row.ready && row.querySelector("[data-look-include]").checked);
      if (!selected.length) { this.status.textContent=this.dataset.empty; return; }
      const invalid=selected.find(row=>!row.variants.some(v=>String(v.id)===row.querySelector("[data-look-variant]").value && v.available));
      if (invalid) { this.status.textContent=this.dataset.required; invalid.querySelector("select").focus(); return; }
      const items=selected.map(row=>({id:row.querySelector("[data-look-variant]").value,quantity:1}));
      this.busy=true;
      this.status.textContent="";
      this.dialog.querySelectorAll("input,select,[data-look-retry],[data-look-close]").forEach(el=>{el.dataset.wasDisabled=String(el.disabled);el.disabled=true;});
      this.update();
      let posted=false;
      let serverError="";
      try {
        const sections=[];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{bubbles:true,detail:{sections}}));
        const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify({items,sections:Array.from(new Set(sections)).slice(0,5),sections_url:window.location.pathname})});
        const result=await response.json();
        if (!response.ok) {
          serverError=typeof result.description==="string" ? result.description : "";
          throw new Error("add");
        }
        posted=true;
        selected.forEach(row=>row.querySelector("[data-look-include]").checked=false);
        const cartResponse=await fetch(`${window.Shopify.routes.root}cart.js`,{cache:"no-store"});
        if(!cartResponse.ok) throw new Error("cart");
        const cart=await cartResponse.json();
        cart.sections=result.sections;
        const drawer=document.querySelector("cart-drawer");
        const bundled=cart.sections && Object.values(cart.sections).every(Boolean);
        this.dialog.close();
        if (!drawer || !bundled || !Object.keys(cart.sections).length || window.themeVariables?.settings.cartType==="page") { window.location.assign(`${window.Shopify.routes.root}cart`); return; }
        document.documentElement.dispatchEvent(new CustomEvent("variant:add",{bubbles:true,detail:{items:result.items,cart,onSuccessDo:"force_open_drawer"}}));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change",{bubbles:true,detail:{baseEvent:"variant:add",cart,onSuccessDo:"force_open_drawer"}}));
      } catch(error) {
        if(posted) { window.location.assign(`${window.Shopify.routes.root}cart`); return; }
        this.status.textContent=`${serverError ? serverError+" " : ""}${this.dataset.error}`;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      } finally {
        this.busy=false;
        this.dialog.querySelectorAll("[data-was-disabled]").forEach(el=>{el.disabled=el.dataset.wasDisabled==="true";delete el.dataset.wasDisabled;});
        this.update();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
